import { createBroadcastBehaviorSubject } from './broadcast-behavior-subject';

export type CrosshairSyncData = {
  time: number | null;
  sourceTimeframeIndex?: number;
  sourceTimeframe?: string; // e.g., "1m", "5m", "15m", "1h", "4h"
  sourceInstanceId?: string;
};

const crosshairPosition$ = createBroadcastBehaviorSubject<CrosshairSyncData>(
  'chart-crosshair-sync',
  {
    time: null
  }
);

export const getCrosshairPosition$ = () => {
  return crosshairPosition$.asObservable();
};

export const updateCrosshairPosition = (data: CrosshairSyncData) => {
  crosshairPosition$.next({
    ...data,
    sourceInstanceId: crosshairPosition$.instanceId
  });
};

export const getCurrentPosition = (): CrosshairSyncData => {
  return crosshairPosition$.getValue();
};

export const getCrosshairSyncInstanceId = () => crosshairPosition$.instanceId;
